import React, { useState } from 'react';
import { Card, Badge } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { Baby, CloudMoon, User, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FetRoomCard = ({ room, bookingCount = 0 }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const navigate = useNavigate();

  const totalRooms = room?.roomCount ;
  const fullyBooked = bookingCount >= totalRooms;
  const availableRooms=totalRooms-bookingCount;
  console.log(totalRooms,fullyBooked,bookingCount,availableRooms)

  return (
    <div className="room-card-wrapper" style={{ flex: '1 1 250px', maxWidth: '290px', minWidth: '230px',marginTop:'5px' }}>
      <Card
        className="shadow-sm rounded overflow-hidden room-card h-100"
        onClick={() => navigate(`/rooms/${room.id}`)}
        style={{ cursor: 'pointer' }}
      >
        <div className="position-relative">
          {!imgLoaded && (
            <div
              className="placeholder-glow"
              style={{ height: 140, backgroundColor: '#e9ecef' }}
            />
          )}
          <Card.Img
            variant="top"
            src={room.roomImage}
            onLoad={() => setImgLoaded(true)}
            style={{
              height: 140,
              objectFit: 'cover',
              display: imgLoaded ? 'block' : 'none',
            }}
          />

          {imgLoaded && fullyBooked && (
            <div className="fully-booked-label">
              <center>Fully booked</center>
            </div>
          )}

          {imgLoaded && !fullyBooked && availableRooms && (
            <div className="avilable-count-label">
              <center>Only {availableRooms} left</center>
            </div>
           
          )}
        </div>

        <Card.Body className="py-2 px-3">
          {!imgLoaded ? (
            <>
              <Skeleton height={18} width={160} />
              <Skeleton height={18} width={80} />
            </>
          ) : (
            <>
              <div
                className="d-flex justify-content-between align-items-center mb-1"
                style={{ fontSize: '0.95rem', color: '#0f172a' }}
              >
                <b>{room.name}</b>
                   <div className="d-flex align-items-center "style={{ fontSize: '0.75rem' }}>
                      <div className="d-flex align-items-center me-2">
                        <Users size={14} className="me-1" color='#54b435'/>
                        <span>{room.occupancy} </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <Baby size={14} className="me-1"color='#54b435'/>
                        <span>{room.childOccupancy} </span>
                      </div>
                  </div>
              </div>
              <div
                className="fw-semibold mb-1"
                style={{ fontSize: '0.9rem', color: '#54b435' }}
              >
                ₹{room.pricePerNight}
                <small className="text-muted ms-1" style={{ fontSize: '0.75rem' }}>
                  / <CloudMoon size={12} /> night
                </small>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default FetRoomCard;
